import { Typography } from '@mui/material';
import classNames from 'classnames';
import { useMemo } from 'react';
import LangEnum from '../../../../../../../../../../../../lang/LangEnum';
import useTeceoStyles from '../../../../../../../../../../../../useTeceoStyles';
import { useTranslation } from '../../../../../../../../../../../translation/TranslationContext';
import { MessageType } from '../../../../../../../../../../types/chat.types';
import { ChatRoomItemProps } from './chatRoomItemMessage.types';

const ChatRoomItemMessage = ({ lastMessage, wasRemoved, weight }: ChatRoomItemProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  const { translate } = useTranslation();

  const validLastMessage =
    lastMessage?.type === MessageType.VIDEO_CALL
      ? translate(LangEnum.STARTED_VIDEO_CALL_MESSAGE)
      : lastMessage?.body;

  const message = useMemo(() => {
    if (wasRemoved) {
      return translate(LangEnum.CHAT_ROOM_MESSAGE_USER_REMOVED);
    }

    if (validLastMessage) {
      return `${lastMessage?.authorName || lastMessage?.authorEmail}: ${validLastMessage}`;
    }

    return translate(LangEnum.CHAT_ROOM_MESSAGE_USER_ADDED);
  }, [lastMessage?.authorEmail, lastMessage?.authorName, translate, validLastMessage, wasRemoved]);

  return message ? (
    <Typography
      color="textPrimary"
      style={{ maxWidth: 170, fontWeight: weight }}
      className={classNames(teceoClasses.truncate)}
    >
      {message}
    </Typography>
  ) : null;
};

export default ChatRoomItemMessage;
